import type { AppSettings, AppSettingsItem } from '@models/master-data/master-data.model';

const LOCAL_APP_SETTINGS_HOST = 'qa7-web-olci-v2.np.flydubai.com';

/** CMS keys are hostnames, not full origins. Localhost falls back to QA v2 OLCI key. */
export const resolveAppSettingsForHost = (appSettings: AppSettings): Partial<AppSettingsItem> => {
  const { hostname, origin } = window.location;
  const localHost =
    hostname === 'localhost' || hostname === '127.0.0.1' ? LOCAL_APP_SETTINGS_HOST : '';

  return (
    appSettings?.[hostname] ??
    appSettings?.[origin] ??
    (localHost ? appSettings?.[localHost] : undefined) ??
    appSettings?.default ??
    {}
  );
};
